(function() {

    'use strict';

    eclipseApp.factory('changePhoneNumberService', function() {

        var cityList = '';

        var cityName = '';
        var provinceName = '';

        function setCityList(data) {
            cityList = data;
        }

        function getCityList() {
            return cityList;
        }

        function setCityName(data) {
            cityName = data;
        }

        function getCityName() {
            return cityName;
        }

        function setProvince(data) {
            provinceName = data;
        }

        function getProvince() {
            return provinceName;
        }

        return {
            setCityList: setCityList,
            getCityList: getCityList,
            getProvince: getProvince,
            setProvince: setProvince,
            setCityName: setCityName,
            getCityName: getCityName
        };

    });


})();
